


































































import { GetFileServiceUrl } from "@/helper/uploadHelper";
import { CheckIsMUZE } from "@/helper/shareHelper";
import { ApplipcationStoreType, Package } from "@/enums/enums";
import { MerchantId, CheckMerchantPackage, CheckMerchantAFPPackage } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ModalLinePEAKConnect from "./ModalLinePEAKConnect.vue";
const IsMUZE = CheckIsMUZE();

const StoreLogIn = namespace("LogIn");

@Component({ components: { ModalLinePEAKConnect } })
export default class ApplicationStore extends Vue {
  private GetFileServiceUrl = GetFileServiceUrl;
  private isShowApplicationStore = false;
  private PeakPeakengineURL = process.env.VUE_APP_PeakEngine;
  private PeakAccountURL = process.env.VUE_APP_PeakAccount;
  private showModalLinePEAKConnect = false;
  private isMUZE = IsMUZE;
  private isFreeTrialPackage = CheckMerchantPackage([Package.Trial]);
  private isMerchantPackageAFP = CheckMerchantAFPPackage();

  @StoreLogIn.Action
  private DoRedirectByApplipcationStore!: (applipcationStoreType: ApplipcationStoreType) => void;

  get isCanUsePeakPayroll() {
    return this.$can("access", "PeakPayroll") && !this.isMerchantPackageAFP;
  }
  get isCanUsePeakTax() {
    return this.$can("access", "PeakTax");
  }
  get isCanUsePeakAsset() {
    return this.$can("access", "PeakAsset");
  }
  get isCanUsePeakBoard() {
    return !this.isMerchantPackageAFP;
  }

  public Hide() {
    this.isShowApplicationStore = false;
  }
  public RedirectToPeak() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Peak);
  }
  public RedirectToNewPeak() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.NewPeak);
  }
  public RedirectToPeakPayroll() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Payroll);
  }
  public RedirectToPeakBoard() {
    this.$router
      .push({
        name: "home",
        query: { emi: MerchantId().PeakEncryption() },
      })
      .catch((err) => {
        return "";
      });
    this.Hide();
  }
  public RedirectToPeakAsset() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Asset);
  }
  public RedirectToPeakTax() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Tax);
  }
  public DoShowModalLinePEAKConnect() {
    this.showModalLinePEAKConnect = true;
    this.Hide();
  }
}
